<div class="relative image-container w-full h-screen">
  @if (slide1()?.src; as src) {
    <div class="frame frame-{{ isEvenIndex() ? '1' : '2' }}">
      <img [src]="src" class="image" />
    </div>
  }
  @if (slide2()?.src; as src) {
    <div class="frame frame-{{ isEvenIndex() ? '1' : '2' }}">
      <img [src]="src" class="image" />
    </div>
  }
</div>
